import { useEffect, useState, type FC } from 'react'
import packageJson from '../../../../package.json'
import { fetchAppMetaJson } from '@/utils/appVersionMeta'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import useLang from '@/hooks/use-lang'

export const VersionDisplayer: FC<{ showText: boolean }> = ({ showText }) => {
  const { lang } = useLang()
  const [buidlInfo, setBuildInfo] = useState<{
    buildDate: string
    version: string
  } | null>(null)

  useEffect(() => {
    const bundleBuildDate = packageJson.buildDate
    if (typeof bundleBuildDate !== 'string' || bundleBuildDate.length === 0) {
      return
    }

    void fetchAppMetaJson().then((meta) => {
      if (!meta) {
        return
      }
      setBuildInfo(meta)
    })
  }, [])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'start',
        alignItems: 'center',
        justifyContent: 'space-between',
        // Détachée du bloc du bas (TEC-1956).
        mt: 2.5,
      }}
    >
      <Typography
        variant="body2"
        textAlign="center"
        fontSize={10}
        color="text.secondary"
      >
        Version {buidlInfo?.version}
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        fontSize={8}
        sx={{
          minWidth: 0,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          opacity: showText ? 1 : 0,
          pointerEvents: showText ? 'auto' : 'none',
          transform: showText ? 'translateX(0)' : 'translateX(-10px)',
          transition: 'opacity 0.3s ease, transform 0.3s ease',
        }}
      >
        {new Date(buidlInfo?.buildDate as string).toLocaleDateString(lang)}
      </Typography>
    </Box>
  )
}
